import React from 'react';
import Declare from './declare.jsx';

const Index = () => {

	return(

		<Declare />

	)

}

export default Index;